import { useTranslation } from "react-i18next";
import { useViewInfo } from "../../../../hooks/UseViewInfo";
import { useState } from "react";
import { Flex, ProgressCircle, View } from "@adobe/react-spectrum";
import styles from './standardStatusFilterDropdown.module.css';
import { ChevronDown, ChevronUp, CircleFill } from "react-bootstrap-icons";
import { ListBox, Item, Link } from "@adobe/react-spectrum";
import { truncateText } from "../../new-message/utils/helpers";

interface IStandardStatusDropdownProps {
    createParams: (filterType: any, filterValue: any) => void;
    filterParams?: any;
}

const StandardStatusFilterDropdown: React.FC<IStandardStatusDropdownProps> = ({
    createParams,
    filterParams }) => {

    const { isMobile } = useViewInfo();
    const { t } = useTranslation('task');
    const _t = (key: string) => t(`task_filters.${key}`, { ns: 'task' });
    const [toggleListVisibility, setToggleListVisibility] = useState<any>({ stateList: true });
    const [stateSelectedKey, setStateSelectedKey] = useState<Set<string>>(new Set(['1']));
    const [showLoader, setShowLoader] = useState<boolean>(false);

    const statusArray: any[] = [
        { ident: '0', title: '<Any>', color: '#6c757d' },
        { ident: '1', title: 'Pending', color: '#0d6efd' },
        { ident: '2', title: 'Completed', color: '#198754' },
        { ident: '3', title: 'Missed Deadline', color: '#ffc107' },
    ];


    const handleSelectionChange = (value: any) => {
        const arrValue = Array.from(value);
        const allStatesCheck = arrValue.includes('0') && arrValue.indexOf('0') !== 0;

        if (allStatesCheck) {
            const allStatesSet = new Set(['0']);
            setStateSelectedKey(allStatesSet);
            createParams('standardStatus', allStatesSet);
        } else {
            const filteredValue = arrValue.filter(item => item !== '0');
            const updateValue = filteredValue.length > 0 ? new Set(filteredValue) : new Set(['0']);
            setStateSelectedKey(new Set(Array.from(updateValue).map(String)));
            createParams('standardStatus', updateValue);
        }
    };


    if (showLoader) {
        return (
            <Flex width="100%" height="100%" UNSAFE_style={{ backgroundColor: 'white' }} justifyContent={'center'} alignContent={'center'} alignItems={'center'}>
                <ProgressCircle aria-label="Loading…" isIndeterminate />
            </Flex>
        );
    } else {
        return (
            <Flex direction={'column'} minWidth={'200px'} maxHeight={'300px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_style={{ overflowY: 'auto' }}>
                <Flex direction={'column'} gap={'4px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.standard_status_container}>
                    <Flex direction={'row'} height={'36px'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'space-between'} UNSAFE_className={styles.standard_status_heading}>
                        <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
                            <View position={'relative'} UNSAFE_className={styles.standard_status_heading_text}>
                                {_t('standard_status')}
                            </View>
                        </Flex>
                        {toggleListVisibility.stateList ? (
                            <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
                        ) : (
                            <ChevronUp onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
                        )}
                    </Flex>
                    <Flex
                        direction={'column'}
                        alignSelf={'stretch'}
                        alignItems={'start'}
                        justifyContent={'start'}
                        UNSAFE_className={styles.standard_status_component}
                        UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}
                    >
                        <ListBox
                            id="listProjectStatus"
                            width="100%"
                            selectionMode="single"
                            defaultSelectedKeys={stateSelectedKey}
                            selectedKeys={stateSelectedKey}
                            items={statusArray}
                            onSelectionChange={(value: any) => {
                                handleSelectionChange(value);
                            }}
                            UNSAFE_style={{ color: '#455a64 !important' }}
                            aria-label="Project status filter"
                        >
                            {(item: any) => (
                                <Item key={item.ident} textValue={item.title}>
                                    <Flex direction={'row'} height={'30px'} UNSAFE_style={{ paddingBottom: '30px' }}>
                                        <View UNSAFE_style={{ paddingTop: '4px', paddingLeft: '4px' }}>
                                            <CircleFill style={{ paddingRight: '10px' }} size={'18px'} color={item.color} />
                                        </View>
                                        <View UNSAFE_style={{ whiteSpace: 'nowrap', color: '#455a64 !important', paddingTop: '5px' }}>
                                            <span title={item.title}>{truncateText(item.title, 18)}</span>
                                        </View>
                                    </Flex>
                                </Item>
                            )}
                        </ListBox>
                    </Flex>
                </Flex>
            </Flex>
        );
    }

};

export default StandardStatusFilterDropdown;